import _ from "underscore";
import UserGroupNodeRenderer from "../UserGroupNodeRenderer";

export default function AccessRightUserGroupNodeRenderer(tree, selectorFilter, expandCollapseCallback, accessRight) {
    UserGroupNodeRenderer.call(this, tree, selectorFilter, expandCollapseCallback);
    this.accessRight = accessRight;
}

AccessRightUserGroupNodeRenderer.prototype = _.create(UserGroupNodeRenderer.prototype);

AccessRightUserGroupNodeRenderer.prototype.getEmptyEntityTooltip = function()
{
    return this.accessRight.getGroupEmptyEntityTooltip();
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/accessRight/AccessRightUserGroupNodeRenderer.js